import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    colors,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Hidden,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoSafe
} from '../../../../St/Reports/UseStyle';
import { typeCosts, typeQties } from "../../../../services/safe-grd-services";
import { Filter, Save, TableChart } from "@material-ui/icons";
import { insh as inshst } from "../../../../Context/InshSt";
import AccountSearchModal from "../../../Accounts/BackEnd/accounts-search-modal";
import TaswyaFiltersDialog from "../Store/Fiters-dialog";
import AccountSelect from "../../../../components/controls/accounts-select";
import { sto } from "../../../../Context/InshData";
import RestInfoDialog from "../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { CSVLink } from "react-csv";

export default function SafesTaswyaHead(props) {
    const {
        AutoOptions,
        rptParams,
        onChangeData,
        onChangeAutoData,
        valueAutos,
        typeTaswya,
        onChangeAutoCost,
        getTransData,
        isOpen,
        setIsOpen,
        openSearchMdl,
        setOpenSearchMdl,
        onFilterByClick,
        GetByFilters,
        setFilters,
        filters,
        SafesEmp,
        optionsSafes,
        prevent,
        setInfoData,
        infoData,
        paramsSubList,
        excelHeaders
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();



    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="no"
                        label={t("order_number")}
                        className={clasTF.rootSafe}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrSafe, readOnly: true }}
                        type="text"
                        name="no" value={rptParams.no} onChange={onChangeData('no')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("ref-no")}
                        placeholder="رقم المرجع"

                        className={clasTF.rootSafe}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrSafe }}
                        type="text"
                        name="refno" value={rptParams.refno} onChange={onChangeData('refno')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.Type_Price}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoCost('Type_Price', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={typeTaswya}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params}
                            label={t("settle_by")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="date"
                        label={t("date")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrSafe }}
                        type="date" format="YYYY-MM-DD"
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="date" value={rptParams.date} onChange={onChangeData('date')}
                    /></Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={optionsSafes}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params}
                            label={t("safe")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        disabled={sto.User_typei == 1 ? false : true}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}

                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.center}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('center', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.center}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params}
                            label={t("costcenter")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }} />}
                    />


                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                    <AccountSelect
                        accounts={AutoOptions?.Accindex}
                        account={valueAutos.acc}
                        onSelect={(newValue) => {
                            onChangeAutoData("acc", newValue);
                        }}
                    />
                </Grid>

                <Grid item lg={4} md={4} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("note")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrSafe }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="text"
                        name="refno" value={rptParams.notes} onChange={onChangeData('notes')}
                    />
                </Grid>
                <Grid container item lg={2} md={2} sm={3} xs={6}>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>

                        <Button
                            // className={clasess.buttonss}
                            style={{ direction: "ltr", backgroundColor: "blue" }}
                            variant="contained"
                            color="primary"
                            fontSize="sm"
                            size="medium"
                            onClick={onFilterByClick}
                            startIcon={<Filter />}
                        >
                            {t("fetch-by")}{" "}
                        </Button>
                    </Grid>
                    {!prevent && (
                        <>
                            <Grid item lg={3} md={3} sm={3} xs={12} >
                                <Hidden only={["xs"]}>
                                    <Button
                                        fullWidth
                                        autoFocus
                                        variant="contained"
                                        color="#000"
                                        onClick={(e) => {
                                            setInfoData({ open: true, })
                                        }}
                                        style={{
                                            background: colors.grey[300],
                                            ...{
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                            },
                                        }}
                                    >
                                        {"القيد" + "  "}
                                    </Button>
                                    
                                </Hidden>
                            </Grid>
                            <Grid item lg={3} md={3} sm={2} xs={12} >
                                <Hidden only={["xs"]}>                                
                                    {paramsSubList  && (
                                    <CSVLink
                                        separator={";"}
                                        filename={"TaswyaReport"}
                                        data={paramsSubList}
                                        headers={excelHeaders}
                                    >
                                        {" "}
                                        <Button
                                            // disabled={fetching}
                                            style={{ direction: "ltr", backgroundColor: "blue" }}
                                            variant="contained"
                                            startIcon={<TableChart />}
                                            size="large"
                                            color="primary"
                                            // style={{ borderRadius: 0 }}
                                            className={ clasui.buttonPurch}
                                        >

                                        </Button>
                                    </CSVLink>
                                )}
                                </Hidden>
                            </Grid>
                        </>
                    )}

                </Grid>

                <TaswyaFiltersDialog
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    filters={filters}
                    GetByFilters={GetByFilters}
                    setFilters={setFilters}
                    groups={AutoOptions?.groups}
                />
                {!prevent && (
                    <RestInfoDialog
                        infoData={infoData}
                        setInfoData={setInfoData}
                        res_id={rptParams.res_id}
                        branch={rptParams.branch}
                        fromInv={0}
                        proc_id={0}
                    />
                )}
            </Grid>
        </React.Fragment>
    );
}
